import React from 'react';
import { Zap } from 'lucide-react';

const SplashScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-indigo-600 flex items-center justify-center">
      <div className="text-center">
        <Zap className="h-16 w-16 text-white mx-auto animate-bounce" />
        <h1 className="text-2xl font-bold text-white mt-4">Smart Deal Switcher</h1>
      </div>
    </div>
  );
};

export default SplashScreen;